import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import SteelBuildingEstimatesWrapper from "@components/layouts/steelbuildingestimatesWrapper";

import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";

export default function SteelBuildingEstimatesHome(): ReactElement {
    return (
        <SteelBuildingEstimatesWrapper>
            <TermsAndConditions
                category="Steel buildings"
                domain="SteelBuildingEstimates.com"
            />
        </SteelBuildingEstimatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
